// sensei-app/common/schemas/collections/studentProgress.js
import { z } from "zod";

// Stores the result of a single attempt at a topic.
const TopicAttemptSchema = z.object({
    attemptId: z.string().uuid().default(() => uuidv4()),
    score: z.number().int().min(0),
    timestamp: z.coerce.date(),
    transcriptDocumentId: z.string().optional().nullable().describe("Link to the class/assessment transcript."),
});

// Tracks the overall progress for a single topic.
const TopicProgressSchema = z.object({
    topicId: z.string().uuid().describe("Links to the TopicDefinition in the Course schema."),
    status: z.enum(["not_started", "in_progress", "completed"]).default("not_started"),
    highestScore: z.number().int().min(0).default(0),
    attempts: z.array(TopicAttemptSchema).optional().default([]),
});

const StudentProgressSchema = z.object({
    _id: z.string().optional(),
    studentId: z.string(),
    courseId: z.string(),
    
    // NEW: Detailed progress tracking per topic
    topicsProgress: z.array(TopicProgressSchema).optional().default([]),
    
    // NEW: Calculated fields for easy access
    totalScore: z.number().int().min(0).default(0).describe("Sum of the highest scores from all mandatory topics."),
    isCompleted: z.boolean().default(false).describe("True if all mandatory topics are completed."),
    hasPassed: z.boolean().default(false).describe("True if isCompleted and totalScore meets passingScore."),
    
    certificateId: z.string().optional().nullable().describe("ID of the issued certificate upon completion."),
    
    lastActivityAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default StudentProgressSchema;